// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__13nwN","header":"ClearentDisclaimer_header__3yv5f","inner":"ClearentDisclaimer_inner__1IEKQ"};